class Utils {
    static buildQueryString(data) {
        let query = [];
        for (let key in data) {
            query.push(encodeURIComponent(key) + '=' + encodeURIComponent(data[key]));
        }
        return '?' + query.join('&');
    }

    static isIos() {
        return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    }

    static buildLinkElement(link) {
        let elm = document.createElement('link');
        elm.setAttribute('href', link);
        elm.setAttribute('type', 'text/css');
        elm.setAttribute('rel', 'stylesheet');
        return elm;
    }
}

module.exports = Utils;
